module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("ONE")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("T")])])])]), _vm._v("he warm September day had turned chilly with sunset, the brisk air heavy with approaching rain. Miranda Sheldon shivered as she stepped outside of her three-story town house, goose bumps rising on her bare arms as clammy coolness seeped through her cotton T-shirt. A jacket would have been a good idea, but she’d been in a hurry to escape the house. Grabbing one had been the last thing on her mind and, as much as she knew she’d probably regret it, she wouldn’t return for one now. Not when her sister Lauren was there.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("And not when memories filled every corner, sorrow every silent room.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_c('span', [_vm._v("Instead, she moved quickly, setting a rapid pace, hoping it would warm her as nothing else had in the past few days. People milled around her as she hurried down the busy Essex street. Many she recognized as patrons of the small bakery she owned. A few called out to her, some offering quiet condolences before moving on to whatever they’d planned for Friday night. Their words echoed in her ears, whispered through her head and lodged in her throat, nearly choking her with their potency. Comfort, sympathy. She wanted neither. What ")])]), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_vm._v("she wanted was to rewind the clock, to change the past, to make different choices that would lead to different outcomes.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('span', [_vm._v("But, of course, she couldn’t do any of those things. All she could do was grieve and move on with a life that seemed empty and void.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('span', [_vm._v("Two blocks down and around a corner, the neighborhood grew quiet, the sounds of traffic and voices muted, the busy Maryland town hushed. Miranda hesitated at the top of a cul-de-sac, the darkness not able to hide the truth of where her walk had taken her. Not just any street. Not just any place. This was where she’d spent the better part of two days. A place where she’d greeted those who’d come to share her sorrow. A place that she’d be happy to walk away from and never see again.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('span', [_vm._v("Earlier, the lawn of the huge Greek revival had gleamed brilliant emerald in the sunlight. Now, it was a blanket of shifting shadows, the half-bare trees that lined the driveway skeletal. Light glowed from the lower level of the building, but the remainder of the house was dark, the tall windows eerie in the moonlight. At night, more than any other time, Green’s Funeral Home looked like what it was—a place for the dead.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('span', [_vm._v("Miranda shivered, but moved forward anyway, knowing that she couldn’t turn back now. She hadn’t planned to come, but she was here and maybe it was for the best. If someone was still working at the funeral home, she might get a chance to say a final goodbye. A "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("private")])]), _vm._v(" goodbye. It was the last opportunity she’d have before the burial. She couldn’t pass it up.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('span', [_vm._v("The foyer of the building was brightly lit and visible through the panes of glass on either side of the door. Miranda knocked, then twisted the knob. It was locked ")])]), _c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_vm._v("as she’d expected, the funeral home empty. She should go home, finish the baking she was doing for the funeral and check over the list of things that had to be ready before tomorrow. That was the practical thing to do. But with her nephew Justin gone, practical didn’t seem quite as important as it once had been. Nor did home seem the comfortable place she’d thought it to be. Maybe once Lauren returned to her work and travels, Miranda could return to the quiet life she’d built for herself.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('span', [_vm._v("Maybe, but she didn’t think so. Her life had changed irrevocably—it would never be the same.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('span', [_vm._v("She clenched her jaw against a sob and stepped around the side of the building. The darkness was complete there, but the past two days had given Miranda plenty of time to become familiar with the grounds. Here, where the shadows were deepest, stone benches sat in shrub-lined alcoves. She sought one out and lowered herself onto it, ignoring the cold that seeped through her jeans. The night enfolded her, the muffled sounds of traffic a backdrop to her thoughts.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('span', [_vm._v("She rested her elbows on her knees and lowered her head into her hands, wanting to pray, but not sure what to pray for. Peace? Acceptance? Forgiveness? The words wouldn’t form, her thoughts refusing to coalesce. How could she pray when she didn’t know what to ask for? And how could she know what to ask for when she couldn’t even begin to imagine tomorrow, let alone a week, month or year from now? She’d spent the past ten years planning her schedule around Justin. With him gone, the future stretched out in front of her, a blank slate—empty and more frightening than she wanted to admit.")])])]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Eventually, Miranda would find a way to let go of the past and move on to the future, find a way to build a life that didn’t include her nephew’s special needs and unique gifts. But not tonight. Tonight she’d do nothing at all. Not plan. Not think. Not worry about the empty years stretching out in front of her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Minutes ticked by, the soft sounds of the night filling her ears, the sweet scent of grass and leaves tickling her nose. Her arms were chilled, her body shivering with cold, but she didn’t want to leave her quiet refuge. Not yet. Instead, she sat in silence, listening to the melody of night creatures mixed with the soft hum of faraway traffic.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("At first the low rumble blended with all the other sounds, the rough purr no different than those of the other cars and trucks that passed by. But soon it grew louder and the noisy intrusion drew Miranda’s attention.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She cocked her head, listening. The sound seemed to come from behind the building, but there was no parking lot there, just a wide expanse of grass and a gently sloping yard that led to a far-off road. Grass crunched beneath tires, the quiet rumble of the engine becoming a low roar. Then there was silence so sudden and complete Miranda’s breathing sounded harsh and loud in comparison. She forced herself to take a slow, deep breath, exhaling quietly as she waited to hear more. When the silence continued, she was sure she’d been mistaken, that a car hadn’t been in the backyard at all, that what she’d heard had come from another direction altogether.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('span', [_vm._v("A door slammed, the sound so close Miranda jumped, biting back a shriek and scrambling to her feet. Voices whispered into the darkness, the tones mascu")])]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_vm._v("line, gruff and definitely coming from behind the building. Whatever was going on, it wasn’t any of Miranda’s business. The best thing she could do was head back to the front of the funeral home and leave. But something pulled her toward the back corner, some strange urging that wouldn’t let her walk away. Her heart hammered against her ribs. Fast. Hard. Insistent. Telling her what she already knew—that she should be walking away from, not toward, the voices.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span', [_vm._v("But it was too late. She could already make out the words, already hear what was being said.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span', [_vm._v("“…crematory is a better idea.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span', [_vm._v("“Takes too long. Cleaning crew will be here at midnight. We’ll bring him out to the cemetery.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span', [_vm._v("“It’s closed. If someone sees us there and calls the cops—”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span', [_vm._v("“You’ve got a funeral tomorrow morning, right?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span', [_vm._v("“Yeah, but—”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span', [_vm._v("“So who’s going to think anything of you being at the cemetery? No one. That’s who. We’ll just drop our friend in the newly dug grave, throw in some dirt. Tomorrow the casket goes in on top of him and, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("voilà,")])]), _vm._v(" our problems are solved.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span', [_vm._v("“I don’t like it. Someone sees us out there messing around with a grave—”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span', [_vm._v("“Who’s going to see? The gate is locked. No one goes there after dark.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span', [_vm._v("“Like I said, I don’t like it. This whole business stinks like—”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span', [_vm._v("“Yeah, so let’s get a move on and get the key to the cemetery gate so we can get it over with.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span', [_vm._v("“Fine. Sure. Get it over with. Stay here with Morran. I’ll go in and get the key.”")])])]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You think I’m staying out here alone with him? No way. Now, come on. We don’t have all night.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The men fell silent, their words hanging in the air, wrapping around Miranda and pulling her into something she was sure she didn’t want to be part of. She needed to move away. Quietly, cautiously. Then, once she was safe, call the police.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But she couldn’t. Not when she might be the only witness to a horrific crime. She crept toward the corner of the building, holding her breath, afraid the smallest sound would alert the men. Pale moonlight illuminated the backyard and an SUV parked there. Three men moved toward the funeral home, weaving a bit as they went, their shoulders pressed close together, their heads bent. They might have been college boys home from a night of partying but for the hostility that emanated from them.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("And Miranda knew her fear was warranted. Knew something horrible was going on. Something violent. Something potentially deadly. Her breath hitched, her eyes straining to see more details, to take in every nuance of the picture. If she got out of this…. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("when")])]), _vm._v(" she got out of this, she wanted to have plenty to tell the police, but the rising moon shone behind the men, casting their faces into shadow. Whoever they were, whatever they planned remained hidden.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('span', [_vm._v("A key scraped against a lock and a door creaked open, dim light spilling out onto the faces of the men. Miranda blinked, biting back a gasp as she caught her first clear sight of them. Two she recognized. Liam Jefferson and Randy Simmons were regulars at Miranda’s bakery. Both were well known in the community, one a police officer, the other the director of the funeral ")])]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v("home. Miranda couldn’t imagine either being involved in anything illegal. At least she wouldn’t have been able to imagine it before tonight.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', [_vm._v("Now she had no doubt as to their true nature. Not when the third man stood between them, blindfolded, his mouth duct taped, his arms pulled tight behind his back. Was this the "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("friend")])]), _vm._v(" Liam and Randy planned to cover with dirt? She’d thought she was hearing details of a crime being hidden, a murder already committed. The truth was so much more horrible than that.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', [_vm._v("Or it would be if she didn’t stop it.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', [_vm._v("No way could she run and leave the man to die. She’d wait until Liam and Randy went into the building, call the police, and then try to get close enough to read the license plate on the SUV.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', [_vm._v("As the men disappeared into the funeral home, Miranda dug through her purse, searching for her cell phone, her damp palm sliding over keys, a packet of tissue, a bottle of aspirin.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', [_vm._v("The phone wasn’t there.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', [_vm._v("In her mind’s eye she could see it, sitting on the kitchen counter, charging. Completely useless.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', [_vm._v("“Stupid. Stupid, stupid, stupid. Of all the nights to leave it at home.” Her whispered words sounded harsh, her breath uneven. She’d write the license plate number down, then run to a neighboring house, pray someone was home and would let her use a phone.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', [_vm._v("The plan had barely formed when the door creaked open again. Randy stepped outside first, his gravely words carrying on the night air. “I don’t know about this, Lee. It doesn’t feel right.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('span', [_vm._v("Liam stepped out next, tugging the blindfolded man, then shoving him ahead a few steps while he turned to ")])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v("close the door. “It doesn’t have to feel right. It just has to be done.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('span', [_vm._v("“But—”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('span', [_vm._v("“But nothing. Morran is scum. Getting rid of him will be doing the world a favor.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('span', [_vm._v("“And saving our behinds.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('span', [_vm._v("“Yeah, well that’s the whole point, isn’t it? Now get him in the car.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('span', [_vm._v("Randy seemed to stiffen at the harsh tone, but obeyed, reaching out for his prisoner’s arm. He never had a chance to grab it. In a flash of movement the blindfolded man lashed out with a foot, knocking him to the ground.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('span', [_vm._v("Miranda gasped, jerked back, then froze as Liam swung toward her. His eyes probed the shadows where she stood, his gaze sweeping the corner of the building. She wanted to run, but knew any movement would have him swooping down on her. Her heart hammered double-time as she waited for discovery. But Liam turned away, stepping back toward the man who stood still as stone, giving no indication that he had moved. Miranda wanted to call out, to warn him, but thick, cottony fear trapped her words. Liam took a step closer and the man pivoted, slamming a foot into his stomach.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('span', [_vm._v("Now both Liam and Randy were down, but they wouldn’t be for long. Already, they were struggling up. It wouldn’t take much time for them to subdue their bound and blindfolded prisoner, to drag him away. To kill him.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('span', [_vm._v("Miranda glanced around, looking for help, for inspiration, for some way to undo what was being done. Her gaze lit on a large planter that sat near the wall of the funeral home. As weapons went, it wasn’t much.")])])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But it was all she had.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Praying for strength and for the element of surprise, Miranda moved toward it.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-539ba4dd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/valleyofshadows_ch01.vue
// module id = 78
// module chunks = 0